class WishlistDelete extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.handleSubmit = this.handleSubmit.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)

    this.els.close.elements.forEach((close) => {
      this.listeners.add(close, 'click', this.handleClose)
    })
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
  }

  handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-delete-external-el="trigger"]',
    )

    if (!trigger || !window._swat) return

    this.els.submit.element.setAttribute(
      'data-wishlist-id',
      trigger.dataset.wishlistId,
    )

    this.setAttribute('aria-hidden', false)
    document.body.classList.toggle('util-SiteOverflowed', true)
  }

  handleSubmit () {
    const lid = this.els.submit.element.dataset.wishlistId

    window._swat.deleteList(lid, window.location.reload(), this.wishlistError)
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`);
  }
}

if (!customElements.get('wishlist-delete')) {
  customElements.define('wishlist-delete', WishlistDelete)
}
